import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Usuario } from 'src/app/shared/models/usuario.model';
import { environment } from 'src/environments/environment';
import { RecuperarSenhaRequest } from '../shared/models/recuperar-senha-request.model';
import { ValidarCadastroRequest } from '../shared/models/validar-cadastro-request.model';
import BrowserUtils from '../shared/utils/browser-utils';
import { ApiService } from '../shared/api/api.service';

@Injectable({
  providedIn: 'root'
})
export class CadastroService {
  private readonly USER_DOCUMENT_SESSION_KEY = '@portal-cb/usr-data'
  private readonly USER_RECAPTCHA = '@portal-cb/usr-rc'

  constructor(
    private httpClient: HttpClient,
    private apiService: ApiService
  ) { }

  cadastrarClientePF(usuario: Usuario): Promise<Usuario> {
    const body: Usuario = { ...usuario };

    const path = this.apiService.getEndpoint({
      apiKey: 'cdc-cobranca-orquestrador-registro',
      path: '/cobranca-orquestrador-registro/cobrancas/cadastro',
      oldBrowserFallbackPath: '/cobrancas/cadastro',
    });

    if (usuario.telefone) {
      body.telefone = `55${usuario.telefone}`;
    }

    return this.httpClient.post<Usuario>(path, body).toPromise();
  }

  confirmarCadastroPF(validarCadastro: ValidarCadastroRequest, cpf: string): Promise<ValidarCadastroRequest> {
    const path = this.apiService.getEndpoint({
      apiKey: 'cdc-cobranca-orquestrador-registro',
      path: `/cobranca-orquestrador-registro/cobrancas/cadastro/${cpf}`,
      oldBrowserFallbackPath: `/cobrancas/cadastro/${cpf}`,
    })

    return this.httpClient.put<ValidarCadastroRequest>(path, validarCadastro).toPromise();

  }

  cadastrarClienteCB(usuario: Usuario): Promise<Usuario> {
    const body: Usuario = { ...usuario };

    const path = this.apiService.getEndpoint({
      apiKey: 'cdc-cobranca-orquestrador-registro',
      path: '/cobranca-orquestrador-registro/cobrancas/cadastro/cliente',
      oldBrowserFallbackPath: '/cobrancas/cadastro/cliente',
    });

    if (usuario.telefone) {
      body.telefone = `55${usuario.telefone}`;
    }

    return this.httpClient.post<Usuario>(path, body).toPromise();
  }

  enviarTokenCadastro(usuario: Omit<Usuario, 'dataNascimento'>): Promise<void> {
    const body = { ...usuario };

    const path = this.apiService.getEndpoint({
      apiKey: 'cdc-cobranca-orquestrador-registro',
      path: '/cobranca-orquestrador-registro/cobrancas/cadastro/envia-token',
      oldBrowserFallbackPath: '/cobrancas/cadastro/envia-token',
    })

    if (usuario.telefone) {
      body.telefone = `55${usuario.telefone}`;
    }
    return this.httpClient.post<void>(path, body).toPromise();
  }


  solicitarRecuperacaoSenha(cpf: string) {
    const path = this.apiService.getEndpoint({
      apiKey: 'cdc-cobranca-orquestrador-registro',
      path: '/cobranca-orquestrador-registro/cobrancas/recuperar-senha/token',
      oldBrowserFallbackPath: '/cobrancas/recuperar-senha/token',
    })

    return this.httpClient.post<ValidarCadastroRequest>(path, { cpf }).toPromise();

  }

  confirmarRecuperacaoSenha(recuperacaoSenha: RecuperarSenhaRequest) {
    const path = this.apiService.getEndpoint({
      apiKey: 'cdc-cobranca-orquestrador-registro',
      path: '/cobranca-orquestrador-registro/cobrancas/recuperar-senha',
      oldBrowserFallbackPath: '/cobrancas/recuperar-senha',
    })

    return this.httpClient.put<ValidarCadastroRequest>(path, recuperacaoSenha).toPromise();
  }

  saveUserDocumentToSessionStorage(document: string) {
    sessionStorage.setItem(this.USER_DOCUMENT_SESSION_KEY, document);
  }

  getUserDocumentFromSessionStorage() {
    return sessionStorage.getItem(this.USER_DOCUMENT_SESSION_KEY);
  }

  saveRecaptcha(recaptcha: string) {
    sessionStorage.setItem(this.USER_RECAPTCHA, recaptcha);
  }

  getRecaptcha() {
    return sessionStorage.getItem(this.USER_RECAPTCHA);
  }

  get apiUrlService(): string {
    if (BrowserUtils.isOldFirefox()) {
      return environment.cdccorpApiURLService;
    }

    return environment.apiURLService;
  }

  clearStorageData() {
    sessionStorage.removeItem(this.USER_DOCUMENT_SESSION_KEY);
    sessionStorage.removeItem(this.USER_RECAPTCHA);
  }

}
